<template>
  <div class="login">
    <div>
      <div class="p1">
        <img src="./../../assets/img/logo.png" alt />
        <!-- <span>理菜宝</span> -->
      </div>
      <div class="login-tab">
        <van-tabs
          background="transparent"
          :border="false"
          title-active-color="#333333"
          title-inactive-color="#999"
          color="#31b158"
          v-model="active"
        >
          <van-tab title="验证码登录" :name="1">
            <div class="login_con mc_login">
              <div class="p_input p_input_mc">
                <div class="p_input_item pi_phone">
                  <img src="./../../assets/img/login/login_username.png" alt class="icon" />
                  <input type="number" placeholder="请输入手机号" v-model="subData_code.mobile" />
                  <van-icon
                    name="cross"
                    v-show="subData_code.mobile"
                    @click="subData_code.mobile=''"
                  />
                </div>
                <div class="p_input_item pi_code">
                  <img src="./../../assets/img/login/login_password.png" alt class="icon" />
                  <input type="number" placeholder="请输入验证码" v-model="subData_code.code" />
                  <button class="sendCode" :disabled="isSend" @click="sendCode">{{sendTxt}}</button>
                </div>
              </div>
              <div class="p_button">
                <div @click="login_code">登 录</div>
              </div>
            </div>
          </van-tab>
          <van-tab title="账号密码登录" :name="2">
            <div class="login_con up_login">
              <div class="p_input p_input_up">
                <div class="pi_phone p_input_item">
                  <img src="./../../assets/img/login/login_username.png" alt class="icon" />
                  <input type="text" placeholder="请输入手机号" v-model="subData.username" />
                  <van-icon name="cross" v-show="subData.username" @click="subData.username=''" />
                </div>
                <div class="pi_password p_input_item">
                  <img src="./../../assets/img/login/login_password.png" alt class="icon" />
                  <input type="password" placeholder="请输入密码" v-model="subData.password" />
                </div>
              </div>
              <div class="p_check">
                <div class="p_forget">
                  <div class="forget" @click="toForget">忘记密码?</div>
                </div>
                <div>
                  <van-checkbox
                    v-model="checked"
                    checked-color="#31b158"
                    shape="square"
                    icon-size="16px"
                  >
                    <span>记住密码</span>
                  </van-checkbox>
                </div>
              </div>
              <div class="p_button">
                <div @click="login">登 录</div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <div class="register">
        <div @click="toUserRegister">没有账号？去注册＞</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, isMobile, isPassword0, isCode4 } from "@/utils/validate";
import { login, sendCode, codeLogin } from "@/api/login";
import { setToken } from "@/utils/auth";
import Cookies from "@/utils/Cookies";
var t;
export default {
  name: "login",
  data() {
    return {
      checked: true,
      active: 1,
      subData: {
        username: "",
        password: "",
        group: "h5"
      },
      subData_code: {
        mobile: "",
        code: "",
        group: "h5"
      },

      isSend: false,
      sendTxt: "发送验证码"
    };
  },
  created() {
    var account = Cookies.get("account");
    if (account) {
      this.subData = {
        username: JSON.parse(account).username,
        password: JSON.parse(account).password,
        group: "h5"
      };
      this.checked = true;
    }
  },
  mounted() {},
  methods: {
    //   登录
    login() {
      if (!isMobile(this.subData.username)) {
        this.$notify({ type: "warning", message: "请输入正确的手机号！" });
      } else if (!isPassword0(this.subData.password)) {
        this.$notify({ type: "warning", message: "请输入正确的密码！" });
      } else {
        const toast = this.$toast.loading({
          message: "登录中...",
          overlay: true,
          forbidClick: true
        });
        login(this.subData).then(res => {
          if (res.code == 200) {
            setToken(res.data.access_token);
            Cookies.set("userInfo", JSON.stringify(res.data.user));
            Cookies.set("shopInfo", JSON.stringify(res.data.shop));
            toast.clear();
            if (this.checked) {
              Cookies.set("account", JSON.stringify(this.subData));
            }
            this.$toast("登录成功");
            Cookies.set("rule", JSON.stringify(res.data.rule));
            var res_z = JSON.parse(Cookies.get("rule"));
            console.log("res", res);
            if (res_z.includes("1") && !res_z.includes("2")) {
              this.$router.push("/openOrder/order");
            } else if (res_z.includes("2")) {
              this.$router.push("/openOrder/orderCheckOut");
            } else {
              this.$router.push("/openOrder/order");
            }
          }
        });
      }
    },
    login_code() {
      if (!isMobile(this.subData_code.mobile)) {
        this.$notify({ type: "warning", message: "请输入正确的手机号！" });
      } else if (!isCode4(this.subData_code.code)) {
        this.$notify({ type: "warning", message: "请输入正确的验证码！" });
      } else {
        const toast = this.$toast.loading({
          message: "登录中...",
          overlay: true,
          forbidClick: true
        });
        codeLogin(this.subData_code).then(res => {
          if (res.code == 200) {
            setToken(res.data.access_token);
            Cookies.set("userInfo", JSON.stringify(res.data.user));
             Cookies.set("shopInfo", JSON.stringify(res.data.shop));
            toast.clear();
            this.$toast("登录成功");
            Cookies.set("rule", JSON.stringify(res.data.rule));
            let res_z = JSON.parse(Cookies.get("rule"));
            if (res_z.includes("1") && !res_z.includes("2")) {
               this.$router.push("/openOrder/order");
            } else if (res_z.includes("2")) {
               this.$router.push("/openOrder/orderCheckOut");
            } else {
              this.$router.push("/openOrder/order");
            }
           
          }
        });
      }
    },
    // 去忘记密码
    toForget() {
      this.$router.push("/forget");
    },
    // 去注册页面
    toUserRegister() {
      this.$router.push("/userRegister");
    },

    // 发送验证码
    sendCode() {
      if (isMobile(this.subData_code.mobile)) {
        this.isSend = true;
        this.sendTxt = "发送中";
        sendCode({ mobile: this.subData_code.mobile, usage: "login" })
          .then(res => {
            if (res.code == 200) {
              this.$toast("验证码发送成功，请注意查收");
              var time = 60;
              var that = this;
              t = setInterval(function() {
                if (time > 0) {
                  that.isSend = true;
                  that.sendTxt = time + "s";
                  time--;
                } else {
                  that.isSend = false;
                  that.sendTxt = "发送验证码";
                  clearInterval(t);
                }
              }, 1000);
            }
          })
          .catch(res => {
            this.isSend = false;
            this.sendTxt = "发送验证码";
          });
      } else {
        this.$notify({ type: "warning", message: "请输入正确的手机号！" });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background-color: #fafafa;
  position: relative;
  & > div {
    // width: 6.1rem;
    // margin: 0 0.7rem;
    width: 100%;
  }
  .p1 {
    padding-bottom: 1rem;
    padding-top: 1.4rem;
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    span {
      width: 100%;
      font-size: 0.42rem;
      font-weight: 600;
      color: rgba(49, 177, 88, 1);
      text-shadow: 0px 0.05rem 0.08rem rgba(49, 177, 88, 0.33);
      letter-spacing: 0.1rem;
    }
    img {
      width: 4rem;
      height: 1.63rem;
    }
  }
  .login-tab {
    width: 6.1rem;
    width: 100%;
    margin: 0 auto;
    position: relative;
    .van-tabs__content {
      padding: 0 0.7rem;
    }
    .login_con {
      padding-top: 0.5rem;
      .p_input {
        position: relative;
        padding: 0 0.7rem;
        .p_input_item {
          width: 5.95rem;
          line-height: 0.88rem;
          border-radius: 0.44rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0px 0.05rem 0.06rem 0px rgba(49, 177, 88, 0.15);
          background-color: #fff;
          overflow: hidden;
          padding-right: 0.15rem;
          & > .icon {
            width: 0.27rem;
            height: 0.34rem;
            padding-left: 0.6rem;
            padding-right: 0.43rem;
          }
          input {
            width: 100%;
            outline: none;
            border: none;
            font-size: 0.3rem;
            color: #333;
            margin-right: 0.2rem;
            &::placeholder {
              color: #cccccc;
            }
          }
          &:last-of-type {
            margin-top: 0.7rem;
          }
        }
        .pi_code {
          input {
            width: 2.8rem;
          }
          .sendCode {
            width: 1.8rem;
            height: 0.6rem;
            border-radius: 0.3rem;
            border: 0.02rem solid #31b158;
            border-radius: 0.3rem;
            font-size: 0.28rem;
            box-sizing: border-box;
            text-align: center;
            line-height: 0.56rem;
            color: #31b158;
            background-color: #fff;
            font-size: 0.26rem;
            &[disabled] {
              border: 0.02rem solid #999;
              color: #999;
            }
          }
        }
      }

      .p_check {
        margin-top: 0.2rem;
        padding: 0 1rem;
        text-align: right;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > div {
          display: inline-block;
        }
        .van-checkbox__label > span {
          color: #999999 !important;
        }
      }
      .p_button {
        padding: 0.83rem 0.7rem 0;
        div {
          width: 6.1rem;
          box-sizing: border-box;
          height: 0.88rem;
          border-radius: 0.44rem;
          font-size: 0.38rem;
          line-height: 0.88rem;
          text-align: center;
          color: #999;
          font-weight: 500;
          border: 0.02rem solid #ccc;
          &:nth-child(1) {
            background: linear-gradient(-90deg, #25a94d, #3fbe66);
            box-shadow: 0px 0.05rem 0.06rem 0px rgba(49, 177, 88, 0.15);
            border: none;
            color: #fff;
          }
        }
      }
      .p_forget {
        // margin-top: 0.49rem;
        text-align: center;
        .forget {
          color: #999999;
          font-size: 0.28rem;
        }
      }
    }
    .mc_login {
    }
  }
  .register {
    // position: fixed;
    // bottom: 0.5rem;
    margin-top: 0.2rem;
    width: 100%;
    text-align: center;
    font-size: 0.26rem;
    color: #999;
    left: 0;
  }
}
</style>

<style lang="less" scoped>
.login-tab {
  width: 100%;
  box-sizing: border-box;
}
</style>